import { memo } from 'react';
import { Outlet } from 'react-router-dom';

import BossWarehouseSidebarPanel from 'components/sidebar/BossWarehouseSidebarPanel';

const WarehouseStatisticsLayout = () => {
  return (
    <div className='flex flex-row relative grow h-full'>
      <div
        className={'aside-container sidebar-full relative grow'}
        style={{ position: 'relative', zIndex: 1, height: 'auto' }}
      >
        <BossWarehouseSidebarPanel />
      </div>
      <div className={'base-container base-container-small !h-full'}>
        <main className='main-container !h-full with-max-width overflow-y-auto my-scroll'>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default memo(WarehouseStatisticsLayout);
